import Toast from 'vue-toastification'
import { defineNuxtPlugin } from '#app'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Toast)
})
